import { render } from "./commonFooter.vue?vue&type=template&id=09f119bc&lang=pug"
import script from "./commonFooter.vue?vue&type=script&lang=js"
export * from "./commonFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__